import React from 'react';
import useDialog from 'hooks/useDialog';
import { Button } from '@mui/material';
import { useNotify, useRefresh, Confirm } from 'react-admin';
import getAxios from 'getAxios';

const axios = getAxios();

const ClearErrorButton = ({
  invoice_id,
  avalaraErrorMessage,
}: {
  invoice_id: number | string;
  avalaraErrorMessage?: string;
}) => {
  const { open, openDialog, closeDialog } = useDialog();
  const refresh = useRefresh();
  const notify = useNotify();

  const onConfirm = async () => {
    try {
      const response = await axios.post(`v3/admin/invoices/${invoice_id}/clear_invoice_errors`);
      notify(response?.data?.message ?? 'Success', { type: 'success' });
    } catch (error: any) {
      notify(error?.message ?? 'Error', { type: 'error' });
    } finally {
      refresh();
      closeDialog();
    }
  };

  return (
    <>
      <Button data-testid="clear-error-button" size="small" onClick={openDialog}>
        Clear Error
      </Button>
      <Confirm
        isOpen={open}
        onClose={closeDialog}
        onConfirm={onConfirm}
        title="Confirm Invoice Error Clearance"
        content={
          <div>
            {avalaraErrorMessage && (
              <p>
                <strong>Avalara Error Message:</strong> {avalaraErrorMessage}
              </p>
            )}
            <p>
              Please ensure that all necessary adjustments for sales tax with Avalara have been
              completed before clearing this error.
            </p>
            <p>
              Confirming this invoice will reset the relevant fields in our system, allowing it to
              be processed again in the next billing cycle.
            </p>
          </div>
        }
      />
    </>
  );
};

export default ClearErrorButton;
